import type { QueryClient } from '@tanstack/react-query';
import { HTTP_STATUS } from 'cpool-constants';

import { assignedUsersQueryKeys } from './assignedUsersQueryKeys';

// 400/403: assignment changed meanwhile (expected), not a bug
export const isAssignmentConflict = (error: Error & { status?: number }) =>
    error.status === HTTP_STATUS.BAD_REQUEST || error.status === HTTP_STATUS.FORBIDDEN;

export const invalidateAssignedUsers = (queryClient: QueryClient, loanRequestId: string) =>
    Promise.all(assignedUsersQueryKeys(loanRequestId).map((queryKey) => queryClient.invalidateQueries({ queryKey })));
